var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleTextBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 788.373,
    height: 385.402,
    viewBox: "0 0 788.373 385.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(-16606 -2183.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M-669.67,2901.5s-6.981-43.879,25.928-24.931,16.953-31.911,33.906-24.931,26.926,33.906,48.865-3.989",
    transform: "translate(17954.91 -556.981)",
    fill: "none",
    stroke: "#07f",
    strokeWidth: 1,
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(17272 2183.598)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(16606 2372.598)",
    fill: "#fe9535",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M10,0,20,18H0Z",
    transform: "translate(17039.824 2542.196) rotate(43)",
    fill: "#07f",
    opacity: 0.29
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleTextBackground);
export default __webpack_public_path__ + "static/media/TriangleTextBackground.2db92a4c5bc284c1bc607fcbb61dd3ae.svg";
export { ForwardRef as ReactComponent };